/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedIconBubbleEmail_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespIconBubbles_user$ref: FragmentReference;
export type PdpRespIconBubbles_user = {|
  +$fragmentRefs: PdpSharedIconBubbleEmail_user$ref,
  +$refType: PdpRespIconBubbles_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespIconBubbles_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b7a8dd895310a3ea7fad8ff60cbc97c3';
module.exports = node;
